<nav class="breadcrumb-nav" aria-label="Breadcrumb" *ngIf="breadcrumbs.length > 1">
  <ol class="breadcrumb-list">
    <li *ngFor="let breadcrumb of breadcrumbs; let last = last; let i = index"
        class="breadcrumb-item" [class.active]="last">
      <ng-container *ngIf="!last">
        <a [routerLink]="breadcrumb.url" class="breadcrumb-link">
          <mat-icon class="breadcrumb-icon" *ngIf="i === 0 && breadcrumb.icon">{{ breadcrumb.icon }}</mat-icon>
          <span>{{ breadcrumb.label }}</span>
        </a>
        <mat-icon class="separator">chevron_right</mat-icon>
      </ng-container>
      <ng-container *ngIf="last">
        <span class="breadcrumb-current">
          <mat-icon class="breadcrumb-icon" *ngIf="breadcrumb.icon">{{ breadcrumb.icon }}</mat-icon>
          <span>{{ breadcrumb.label }}</span>
        </span>
      </ng-container>
    </li>
  </ol>
</nav>
